{
    "advanced": {
        "action_list": "Lista de acciones",
        "helpers": "Ayudantes",
        "hide": "Ocultar",
        "loading_workers": "Cargando trabajadores",
        "run": "Correr",
        "show": "Mostrar",
        "sim_options": "Opciones de simulación",
        "substat_helper": "Asistente de substat",
        "workers_available": "Trabajadores disponibles: "
    },
    "artifact_names": {
        "archaicpetra": "Petra Arcaica",
        "berserker": "Berserker",
        "blizzardstrayer": "Nómada del Invierno",
        "bloodstainedchivalry": "Caballería Sanguinaria",
        "braveheart": "Corazón del Guerrero",
        "crimsonwitchofflames": "Bruja Carmesí en Llamas",
        "defenderswill": "Corazón del Guardián",
        "emblemofseveredfate": "Emblema del Destino",
        "gambler": "Jugadora",
        "gladiatorsfinale": "Final del Gladiador",
        "heartofdepth": "Corazón de las Profundidades",
        "huskofopulentdreams": "Cáscara de Sueños Opulentos",
        "instructor": "Instructor",
        "lavawalker": "Virtuoso Corredor de Lava",
        "maidenbeloved": "Doncella Amada",
        "martialartist": "Artista Marcial",
        "noblesseoblige": "Ritual Antiguo de la Nobleza",
        "oceanhuedclam": "Perla Oceánica",
        "paleflame": "Llamas Albinas",
        "prayersfordestiny": "Ritual del Destino",
        "prayersforillumination": "Ritual de la Iluminación",
        "prayersforwisdom": "Ritual de la Sabiduría",
        "prayerstospringtime": "Ritual de la Primavera",
        "resolutionofsojourner": "Corazón del Viajero",
        "retracingbolide": "Retroceso del Meteorito",
        "scholar": "Erudita",
        "shimenawasreminiscence": "Reminiscencia de la Purificación",
        "tenacityofthemillelith": "Tenacidad de la Geoarmada",
        "theexile": "Exiliado",
        "thunderingfury": "Furia del Trueno",
        "thundersoother": "Domador de Truenos",
        "tinymiracle": "Milagro",
        "viridescentvenerer": "Sombra Verde Esmeralda",
        "wandererstroupe": "Orquesta del Errante"
    },
    "character": {
        "artifact_stats": "Atributos de artefactos",
        "c_post": "",
        "c_pre": "C",
        "lvl": "Nivel",
        "talents": "Talentos"
    },
    "characteredit": {
        "add_set_bonus": "Agregar bono del conjunto",
        "anemo": "Anemo%",
        "artifact_stats_main": "Atributos de artifactos (Principal + Sub)",
        "ascension": "Ascensión",
        "atk_atk": "Atq/Atq%",
        "attack": "Ataque",
        "burst": "Definitiva",
        "cd": "Daño crítico",
        "change": "Cambiar",
        "character": "Personaje",
        "cons": "Constelationes",
        "cr": "Prob. crítico",
        "cryo": "Cryo%",
        "def_def": "Def/Def%",
        "electro": "Electro%",
        "em": "Maestría elemental",
        "er": "Recarga de energía",
        "geo": "Geo%",
        "heal": "Curación%",
        "hp_hp": "Vida/Vida%",
        "hydro": "Hydro%",
        "level": "Nivel",
        "phy": "Phy%",
        "pyro": "Pyro%",
        "refine": "Refinamiento",
        "set_bonus": "Bono de conjunto:",
        "skill": "Habilidad elemental",
        "weapons_and_artifacts": "Armas y artefactos"
    },
    "character_names": {
        "aether": "Éter",
        "lumine": "Lumina",
        "albedo": "Albedo",
        "aloy": "Aloy",
        "amber": "Amber",
        "barbara": "Bárbara",
        "beidou": "Beidou",
        "bennett": "Bennett",
        "chongyun": "Chongyun",
        "diluc": "Diluc",
        "diona": "Diona",
        "eula": "Eula",
        "fischl": "Fischl",
        "ganyu": "Ganyu",
        "hutao": "Hu Tao",
        "jean": "Jean",
        "kazuha": "Kaedehara Kazuha",
        "kaeya": "Kaeya",
        "ayaka": "Kamisato Ayaka",
        "keqing": "Keching",
        "klee": "Klee",
        "sara": "Kujou Sara",
        "lisa": "Lisa",
        "mona": "Mona",
        "ningguang": "Ninguang",
        "noelle": "Noelle",
        "qiqi": "Qiqi",
        "raiden": "Shogun Raiden",
        "razor": "Razor",
        "rosaria": "Rosaria",
        "kokomi": "Sangonomiya Kokomi",
        "sayu": "Sayu",
        "sucrose": "Sacarosa",
        "tartaglia": "Tartaglia",
        "thoma": "Thoma",
        "venti": "Venti",
        "xiangling": "Xiangling",
        "xiao": "Xiao",
        "xingqiu": "Xingchiu",
        "xinyan": "Xinyan",
        "yanfei": "Yanfei",
        "yoimiya": "Yoimiya",
        "zhongli": "Zhongli",
        "gorou": "Gorou",
        "itto": "Arataki Itto",
        "shenhe": "Shenhe",
        "yunjin": "Yun Jin",
        "yaemiko": "Yae Miko"
    },
    "components": {
        "close": "cerrar",
        "currently_loaded_workers": "Trabajadores cargados actualmente: ",
        "no_characters": "Sin personajes",
        "result_post": "ms con DPS promedio: ",
        "result_pre": "Simulación completada en ",
        "running_simulation": "Corriendo simulación:",
        "see_results_in": "Ve Resultados En El Visor",
        "set": "Colocar",
        "simulation_exited_with": "Simulación salió con error: ",
        "workers_post": " trabajadores",
        "workers_pre": "Corriendo simulador con "
    },
    "dash": {
        "about": "Acerca de",
        "advanced_mode": "Modo avanzado",
        "contribute": "Contribuye",
        "desktop_tool": "Herramienta de escritorio",
        "documentation": "Documentación",
        "is_a_team": "es un simulador de DPS de equipo para Genshin Impact. Empieza seleccionando una de las siguientes opciones!",
        "simulator": "Simulador",
        "teams_db": "DB de equipos",
        "viewer": "Visor"
    },
    "db": {
        "author": "Autor: ",
        "average_dps_per": "DPS promedio por objetivo: ",
        "c_post": "",
        "c_pre": "C",
        "cancel": "Cancelar",
        "character": "Personaje",
        "continue": "Continuar",
        "description": "Descripción:",
        "details": "Detalles",
        "er": "ER: ",
        "error_loading_database": "Error cargando base de datos. No se encontraron datos",
        "filters": "Filtros:",
        "hash": "Hash: ",
        "load_in_simulator": "Cargar en simulador",
        "loading": "Cargando ...",
        "number_of_targets": "Numero de objetivos: ",
        "r": " R",
        "show_in_viewer": "Mostrar en el Visor",
        "total_dps": "DPS total: ",
        "type_to_search": "Escriba para buscar...",
        "weapon": "Arma"
    },
    "footer": {
        "gcsim_is_not": "gcsim no está afiliado con mihoyo. Genshin Impact, el contenido del juego y sus materiales son marcas registradas y derechos de autor de miHoYo."
    },
    "importer": {
        "import_success": "Datos de GOOD importados exitosamente"
    },
    "links": {
        "error_loading_database": "Error cargando base de datos. No se encontraron datos"
    },
    "nav": {
        "about": "Acerca",
        "advanced": "Avanzado",
        "chinese": "中文",
        "english": "English",
        "japanese": "日本語",
        "spanish": "Español",
        "language": "Idioma:",
        "simulator": "Simulador",
        "teams_db": "DB de equipos",
        "viewer": "Visor"
    },
    "sim": {
        "loading_simulator_please": "Cargando simulador. Por favor espere"
    },
    "simple": {
        "action_list": "Lista de acciones",
        "add_character": "Agregar personaje",
        "discord_post": " si necesitas algunas ideas.",
        "discord_pre": "Ingresa la lista de acciones que deseas usar en la caja de texto debajo. Tenemos una vasta colección de lista de acciones compartidas por usuarios en nuestro ",
        "documentation": "documentación",
        "documentation_post": " que incluye un simple tutorial en como escribir listas secuenciales (previamente conocidas como modo cálculo).",
        "documentation_pre": "Alternativamente, checa nuestra ",
        "done": "Listo",
        "exit_edit": "Salir de edición",
        "give_me_back": "Regresame mis tooltip!",
        "hide": "Ocultar",
        "hide_all_tips": "Ocultar todos los tips",
        "loading_workers": "Cargando trabajadores",
        "run": "Correr",
        "show": "Mostrar",
        "sim_options": "Opciones de simulación",
        "start_by_adding": "Empieza por agregar miembros de equipo",
        "team": "Equipo",
        "video": "video",
        "video_post": " como guía inicial.",
        "video_pre": "Empieza por agregar miembros de equipo. checa este ",
        "workers_available": "Trabajadores disponibles: "
    },
    "src": {
        "this_page_is": "Esta página no está implementada aún. Manténganse al tanto!"
    },
    "viewer": {
        "ability_usage_count": "Recuento de uso de habilidad elemental (Promedio)",
        "api_key_supporters": "Llave API (Solo para apoyadores)",
        "attack": "Ataque",
        "average_character_field": "Tiempo de campo promedio por personaje",
        "average_dps_by": "DPS promedio por personaje",
        "avg_dps": "DPS promedio",
        "built_on": ", creado en: ",
        "cancel": "Cancelar",
        "cd": "CD",
        "clear": "Limpiar",
        "close": "Cerrar",
        "combined": "Combinado",
        "config": "Config",
        "continue": "Continuar",
        "copied_to_clipboard": "Copiado al portapapeles",
        "copy": "Copiar",
        "copy_link": "Copiar Link",
        "cr": "CR",
        "create_a_shareable": "Crea un link compartible",
        "damage_dealt_over": "Daño inflingido a lo largo del tiempo",
        "debug": "Depurar",
        "debug_settings": "Opciones de depuración",
        "defaults": "Por defecto",
        "defense": "Defensa",
        "details": "Detalles",
        "dps_by_ability": "DPS por habilidad (Promedio)",
        "em": "Maestría elemental",
        "er": "Recarga de energía",
        "error_copying_not": "Error copiando :( No estoy seguro que fue mal, échale la culpa a SRL",
        "error_encountered": "error encontrado: ",
        "git_hash": "git hash: ",
        "hp": "Vida",
        "level": "Nivel",
        "link_is_permanent": "Link es permanente. ",
        "link_post": "Resultados pueden verse en: ",
        "link_pre": "Subida exitosa. ",
        "link_will_expire": "Link va a expirar en 7 días. ",
        "load_this_configuration": "Carga esta configuración en modo avanzado.",
        "log_options": "Opciones de registro",
        "make_link_permanent": "Hacer el link permanente?",
        "note_that_by": "Tenga en cuenta que por defecto los links compartibles solo son válidos por 7 días. Esto se hace en orden para mantener el almacenamiento del servidor dentro de un nivel razonable. Contribuyentes y apoyadores Ko-Fi pueden ingresar una llave privada para hacer sus links permanentes.",
        "particles_count": "Recuento de partículas",
        "please_note_that": "Por favor tenga en cuenta que esto no es un intento para hacer que las personas nos donen dinero. Esta es una simple manera de controlar la cantidad de datos que son compartidos y almacenados, mientras les damos un pequeño agradecimiento a aquellos que han apoyado este proyecto de forma financiera o por contribuciones. Si necesitas un link permanente y no tienes una llave de acceso, simplemente llégale a nuestro Discord y pide a alguien para que lo haga por ti.",
        "reactions_triggered": "Reacciones activadas",
        "refinement": "Refinamiento",
        "sec_post": "s de combate (",
        "sec_pre": "Simulados ",
        "send_to_simulator": "Mandar a simulador",
        "share": "Compartir",
        "substats": "Substats",
        "summary": "Resumen",
        "target": "Objetivo",
        "this_will_overwrite": "Esto sobreescribirá cualquier configuración existente que tengas. Estás seguro que deseas continuar?",
        "time_post": "s para correr).",
        "time_pre": " iteraciones tomaron ",
        "unknown": "desconocido",
        "upload": "Subir",
        "upload_failed": "subida fallida"
    },
    "viewerdashboard": {
        "drag_n_drop": "Arrastra y suelta un archivo JSON gzip (.gz) de gcsim aquí, o click para seleccionar",
        "drop_the_file": "Suelte el archivo aquí ...",
        "error_retrieving_specified": "error recuperando la URL específica",
        "or_select_from": "O selecciona de los siguientes archivos abiertos previamente (se borrarán cuando la pagina recargue):",
        "upload_a_file": "Subir un archivo",
        "url_does_not": "URL no contiene un archivo JSON gzip válido (.gz)"
    },
    "weapon_names": {
        "akuoumaru": "Rey del Mal",
        "alleyhunter": "Cazador del Callejón",
        "amenomakageuchi": "Espada Amenoma Gemela",
        "amosbow": "Arco de Amos",
        "apprenticesnotes": "Apuntes del Aprendiz",
        "aquilafavonia": "Aquila Favonia",
        "beginnersprotector": "Lanza del Principiante",
        "blackcliffagate": "Ágata del Peñasco Oscuro",
        "blackclifflongsword": "Espada Larga del Peñasco Oscuro",
        "blackcliffpole": "Lanza del Peñasco Oscuro",
        "blackcliffslasher": "Gran Hoja del Peñasco Oscuro",
        "blackcliffwarbow": "Arco del Peñasco Oscuro",
        "blacktassel": "Borla Negra",
        "bloodtaintedgreatsword": "Gran Espada Sangrienta",
        "calamityqueller": "Pacificadora del Desastre",
        "cinnabarspindle": "Huso de Cinabrio",
        "compoundbow": "Arco Compuesto",
        "coolsteel": "Hoja Fría",
        "crescentpike": "Pica Luna Creciente",
        "darkironsword": "Espada de Hierro Oscuro",
        "deathmatch": "Lanza del Duelo",
        "debateclub": "Garrote del Debate",
        "dodocotales": "Cuentos de Dodoco",
        "dragonsbane": "Perdición del Dragón",
        "dragonspinespear": "Lanza de Espinadragón",
        "dullblade": "Hoja Desafilada",
        "elegyfortheend": "Elegía del Fin",
        "emeraldorb": "Orbe Esmeralda",
        "engulfinglightning": "Luz del Segador",
        "everlastingmoonglow": "Luna Inalterable",
        "eyeofperception": "Ojo de la Perspicacia",
        "favoniuscodex": "Códice de Favonius",
        "favoniusgreatsword": "Gran Espada de Favonius",
        "favoniuslance": "Lanza de Favonius",
        "favoniussword": "Espada de Favonius",
        "favoniuswarbow": "Arco de Favonius",
        "ferrousshadow": "Sombra Férrea",
        "festeringdesire": "Deseo Ponzoñoso",
        "filletblade": "Hoja de Filetear",
        "freedomsworn": "Juramento por la Libertad",
        "frostbearer": "Frío Eterno",
        "hakushinring": "Anillo de Hakushin",
        "halberd": "Alabarda",
        "hamayumi": "Masacrademonios",
        "harbingerofdawn": "Espada del Alba",
        "huntersbow": "Arco del Cazador",
        "ironpoint": "Punta de Hierro",
        "ironsting": "Espina de Hierro",
        "kagurasverity": "Axioma de la Kagura",
        "katsuragikirinagamasa": "Asesinato de Katsuragi",
        "kitaincrossspear": "Cruz de Kitain",
        "lionsroar": "Rugido del León",
        "lithicblade": "Espada Lítica",
        "lithicspear": "Lanza Lítica",
        "lostprayertothesacredwinds": "Oración Perdida a los Vientos Sagrados",
        "luxurioussealord": "Rey de los Mares",
        "magicguide": "Guía Mágica",
        "mappamare": "Carta Náutica",
        "memoryofdust": "Candado Terrenal",
        "messenger": "Mensajero",
        "mistsplitterreforged": "Reflejo de las Tinieblas",
        "mitternachtswaltz": "Vals Nocturno",
        "mouunsmoon": "Luna de Mouun",
        "oathsworneye": "Ojo del Juramento",
        "oldmercspal": "Espada del Mercenario",
        "otherworldlystory": "Historias de Otros Mundos",
        "pocketgrimoire": "Grimorio de Bolsillo",
        "polarstar": "Estrella Invernal",
        "predator": "Depredador",
        "primordialjadecutter": "Cortador de Jade Primordial",
        "primordialjadewingedspear": "Halcón de Jade",
        "prototypeamber": "Prototipo Ámbar",
        "prototypearchaic": "Prototipo Arcaico",
        "prototypecrescent": "Prototipo Luz de Luna",
        "prototyperancour": "Prototipo Rencor",
        "prototypestarglitter": "Prototipo Estelar",
        "rainslasher": "Segadora de la Lluvia",
        "ravenbow": "Arco de Cuervo",
        "recurvebow": "Arco Recurvo",
        "redhornstonethresher": "Espadón Cornirrojo",
        "royalbow": "Arco Real",
        "royalgreatsword": "Gran Espada Real",
        "royalgrimoire": "Grimorio Real",
        "royallongsword": "Espada Real Larga",
        "royalspear": "Lanza de Caza Real",
        "rust": "Herrumbre",
        "sacrificialbow": "Arco del Sacrificio",
        "sacrificialfragments": "Memorias de Sacrificios",
        "sacrificialgreatsword": "Gran Espada de Sacrificio",
        "sacrificialsword": "Espada de Sacrificio",
        "seasonedhuntersbow": "Arco del Cazador Estacional",
        "serpentspine": "Médula de la Serpiente Marina",
        "sharpshootersoath": "Juramento del Arquero",
        "silversword": "Espada Plateada",
        "skyridergreatsword": "Gran Espada Surcacielos",
        "skyridersword": "Espada Surcacielos",
        "skywardatlas": "Pergamino Celestial",
        "skywardblade": "Hoja Afilada Celestial",
        "skywardharp": "Alas Celestiales",
        "skywardpride": "Orgullo Celestial",
        "skywardspine": "Púa Celestial",
        "slingshot": "Tirachinas",
        "snowtombedstarsilver": "Argento Estelar de las Nieves",
        "solarpearl": "Perla Solar",
        "songofbrokenpines": "Oda de los Pinos",
        "staffofhoma": "Báculo de Homa",
        "summitshaper": "Rompemontañas",
        "swordofdescension": "Espada del Descenso",
        "thealleyflash": "Destello en la Oscuridad",
        "thebell": "Espada del Tiempo",
        "theblacksword": "Espada Negra",
        "thecatch": "La Captura",
        "theflute": "Flauta",
        "thestringless": "Último Acorde",
        "theunforged": "Espada de la Desidia",
        "theviridescenthunt": "Arco de la Cazadora Esmeralda",
        "thewidsith": "Sinfonía de los Merodeadores",
        "thrillingtalesofdragonslayers": "Cuentos de Cazadores de Dragones",
        "thunderingpulse": "Agitador del Relámpago",
        "travelershandysword": "Espada del Viajero",
        "twinnephrite": "Nefrita Gemela",
        "vortexvanquisher": "Lanza Perforanubes",
        "wastergreatsword": "Gran Espada del Guerrero",
        "wavebreakersfin": "Aleta Cortaolas",
        "whiteblind": "Sombra Blanca",
        "whiteirongreatsword": "Espada de Hierro Blanco",
        "whitetassel": "Borla Blanca",
        "windblumeode": "Oda a las Flores de Viento",
        "wineandsong": "Vino y Poesía",
        "wolfsgravestone": "Lápida del Lobo"
    }
}